import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const attachmentsInit = {
  'clientId': null,
  'infoCertification': null,
  'disabilityCard': null,
  'billFile': null,
};

const INITIAL_STATE_CONTRIBUTOR_LIST = {
  'loadingAttachments': false,
  'rawAttachments': {...attachmentsInit},
  'currentFileType': null,
  'isModalOpen': false,
  'id': null,
  'disabled': false,
};

export const manageFlFiles = (state, action) => {
  return createReducer(INITIAL_STATE_CONTRIBUTOR_LIST, {
    [ActionTypes.FETCHING_FLOATING_INVENTORY_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': true,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY_ATTACHMENTS]: (state, action) => ({
      ...state,
      'rawAttachments': action.response.data,
      'loadingAttachments': false,
    }),
    [ActionTypes.FETCHED_FLOATING_INVENTORY_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
      'rawAttachments': {...attachmentsInit},
    }),

    [ActionTypes.SAVING_FLOATING_INVENTORY_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': true,
    }),
    [ActionTypes.SAVED_FLOATING_INVENTORY_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
      'rawAttachments': action.response.data,
    }),
    [ActionTypes.SAVED_FLOATING_INVENTORY_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
    }),
    [ActionTypes.OPEN_MODAL_INV_FILES]: (state, action) => ({
      ...state,
      'isModalOpen': !!action.payload,
      'currentFileType': action.payload?.fileType || null,
      'id': action.payload?.id || null,
    }),
    [ActionTypes.CLEAR_FL_INVENTORY_FILES]: (state) => ({
      ...state,
      'loadingAttachments': false,
      'rawAttachments': {...attachmentsInit},
      'currentFileType': null,
      'isModalOpen': false,
      'id': null,
    }),
    [ActionTypes.SET_DISABLE_INVENTORY_FILES]: (state, action) => ({
      ...state,
      'disabled': action.payload,
    }),
  })(state, action);
};
